export const trackFacebookEvent = (eventName, eventData = {}) => {
  if (window.fbq) {
    window.fbq("track", eventName, eventData);
    console.log(`Facebook Event: ${eventName}`, eventData);
  } else {
    console.warn("Facebook Pixel not initialized yet.");
  }
};
